import { ObjectGreenDrivingComponent } from './admin-panel/Objects/objects-dialog-base/object-green-driving/object-green-driving.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';

import { SystemRoutingModule } from './system-routing.module';
import { TrackingComponent } from './tracking/tracking.component';
import { ReportsComponent } from './reports/reports.component';
import { HistoryComponent } from './history/history.component';
import { ServiceComponent } from './service/service.component';
import { DriversComponent } from './drivers/drivers.component';
import { DispatcherComponent } from './dispatcher/dispatcher.component';
import { SystemComponent } from './system.component';

import { FilterByNamePipe } from "./shared/pipes/FilterByName.pipe";
import { FilterByNameAndListPipe } from "./shared/pipes/FilterByNameAndList.pipe";
import { FilterByNameAndGroupPipe } from "./shared/pipes/FilterByNameAndGroup.pipe";
import { FilterObjectsPipe } from "./shared/pipes/FilterObjects.pipe";
import { FilterByPagesPipe } from "./shared/pipes/FilterByPages.pipe";
import { FilterTasksPipe } from "./shared/pipes/FilterTasks.pipe";
import { FilterKeysPipe } from "./shared/pipes/FilterKeys.pipe";

import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardSideNavComponent } from './dashboard/dashboard-side-nav/dashboard-side-nav.component';
import { ObjectsDashboardComponent } from './dashboard/objects-dashboard/objects-dashboard.component';

import { LeftTrackComponent } from './tracking/left-track/left-track.component';
import { DevicesListComponent } from './tracking/left-track/devices-list/devices-list.component';
import { GeozonesListComponent } from './tracking/left-track/geozones-list/geozones-list.component';
import { DriversListComponent } from './tracking/left-track/drivers-list/drivers-list.component';
import { DeviceInfoComponent } from './tracking/left-track/device-info/device-info.component';
import { DeviceInfoMenuComponent } from './tracking/left-track/device-info-menu/device-info-menu.component';
import { GeozoneInfoComponent } from './tracking/left-track/geozone-info/geozone-info.component';
import { DriverInfoComponent } from './tracking/left-track/driver-info/driver-info.component';

import { EventsListComponent } from './tracking/right-track/events-list/events-list.component';
import { RightTrackComponent, RightComponentWithCollapsedPanel } from './tracking/right-track/right-track.component';

import { RightHistoryComponent } from './history/right-history/right-history.component';
import { RawDataHistoryComponent } from './history/right-history/raw-data-history/raw-data-history.component';
import { ShortTrendComponent } from './history/right-history/short-trend/short-trend.component';
import { TrackInfoComponent } from './history/right-history/track-info/track-info.component';
import { ObjectsStatComponent } from './history/right-history/objects-stat/objects-stat.component';

import { LeftReportComponent } from './reports/left-report/left-report.component';
import { TrendListComponent } from './reports/trend/trend-list/trend-list.component';

import { DiagnosticsComponent } from './diagnostics/diagnostics.component';
import { SetPayedTillDialogComponent } from './diagnostics/set-payed-till-dialog/set-payed-till-dialog.component';

import { DataReportComponent } from './data/data.component';
import { RawDataComponent } from './data/right-data/raw-data/raw-data.component';
import { DailyStatComponent } from './data/right-data/daily-stat/daily-stat.component';
import { DriverSessionsComponent } from './data/right-data/driver-sessions/driver-sessions.component';
import { LeftDataComponent } from './data/left-data/left-data.component';

import { DriversDashboardComponent } from './drivers/drivers-dashboard/drivers-dashboard.component';
import { DriversSideNavComponent } from './drivers/drivers-side-nav/drivers-side-nav.component';
import { DriversRatingComponent } from './drivers/drivers-rating/drivers-rating.component';
import { DriversReportComponent } from './drivers/drivers-report/drivers-report.component';
import { DriverAnaliticsComponent } from './drivers/drivers-analitics/drivers-analitics.component';
import { TrackInfoWithViolationsComponent } from './drivers/drivers-analitics/track-info-with-violations/track-info-with-violations.component';
import { ViolationsListComponent } from './drivers/drivers-analitics/violations-list/violations-list.component';
import { DriversStatComponent } from './drivers/drivers-analitics/drivers-stat/drivers-stat.component';

import { ServiceSideNavComponent } from './service/service-side-nav/service-side-nav.component';
import { CompletedWorksListComponent } from './service/completed-works-list/completed-works-list.component';
import { ServiceTasksListComponent } from './service/service-list/service-list.component';
import { ServiceTasksReportComponent } from './service/service-report/service-report.component';
import { ServiceCheckupsComponent } from './service/service-checkup/service-checkup.component';

import { RaceDialogBaseComponent } from './races/race-dialog/race-dialog-base.component';
import { RaceDevicesDialogComponent } from './races/race-devices-dialog/race-devices-dialog.component';
import { RaceComponent } from './races/Race/race.component';
import { RacesComponent } from './races/races.component';

import { GapComponent } from './races/Gap/gap.component';

import { DispatcherTableComponent } from './dispatcher/dispatcher-table/dispatcher-table.component';
import { DispatcherReportComponent } from './dispatcher/dispatcher-report/dispatcher-report.component';
import { DispatcherSideNavComponent } from './dispatcher/dispatcher-side-nav/dispatcher-side-nav.component';

import { DropdownDirective } from './shared/directives/dropdown.directive';
import { PaginationComponent } from "./shared/components/pagination/pagination.component";
import { NavigationComponent } from './shared/components/navigation/navigation.component';
import { NotificationPanelComponent } from './shared/components/notification-panel/notification-panel.component';
import { CommandDialogComponent } from './shared/components/command-dialog/c.component';
import { PhotoDialogComponent } from './shared/components/photo-dialog/c.component';
import { PhotoGalleryDialogComponent } from './shared/components/photo-gallery-dialog/photo-gallery-dialog.component';
import { CommonDialogsComponent } from './shared/components/common-dialogs/common-dialogs.component';
import { UsersDialogComponent } from './shared/components/users-dialog/users-dialog.component';
import { SimpleMapComponent } from './shared/components/simple-map/c.component';
import { ImageUploadComponent } from './shared/components/image-upload/image-upload.component';
import { FileUploadComponent } from './shared/components/file-upload/file-upload.component';
import { FormsModule } from "@angular/forms";
import { DeviceEditorComponent } from "./shared/components/devices-editor/devices-editor.component";
import { AdminPanelComponent } from './admin-panel/admin-panel.component';
import { SideNavComponent } from './admin-panel/side-nav/side-nav.component';
import { CommandsComponent } from "./admin-panel/Commands/commands-component/commands.component";
import { CreateCommandComponent } from './admin-panel/Commands/create-command/create-command.component';
import { EditCommandComponent } from './admin-panel/Commands/edit-command/edit-command.component';
import { CommandDialogBaseComponent } from './admin-panel/Commands/command-dialog-base/command-dialog-base.component';
import { AdminDriversComponent } from "./admin-panel/Drivers/drivers-component/drivers.component";
import { ObjectsManagementDialogComponent } from './admin-panel/objects-management-dialog/objects-management-dialog.component';
import { GroupFilterComponent } from './shared/components/group-filter/group-filter.component';
import { ObjectsFilterComponent } from './shared/components/objects-filter/objects-filter.component';
import { GroupManagementDialogComponent } from './admin-panel/group-management-dialog/group-management-dialog.component';
import { ObjectsComponentComponent } from './admin-panel/Objects/objects-component/objects.component';
import { UsersComponent } from './admin-panel/Users/users/users.component';
import { KeysComponent } from './admin-panel/Keys/keys/keys.component';
import { TasksComponent } from "./admin-panel/Tasks/tasks/tasks.component";
import { RoutesComponent, ZoneOrderPipe } from "./admin-panel/Routes/routes/routes.component";
import { ShiftsComponent } from "./admin-panel/Shifts/shifts/shifts.component";
import { ServerAdminComponent } from "./admin-panel/Server/server-admin.component";
import { ServerSettingsComponent } from "./admin-panel/Server/server-settings/server-settings.component";
import { DomainSettingsComponent } from "./admin-panel/Server/server-settings/domain-settings/domain-settings.component";
import { ServerStatusComponent } from "./admin-panel/Server/server-status/server-status.component";
import { BaseAdminPanelComponent } from './admin-panel/base-admin-panel/base-admin-panel.component';
import { GroupBaseAdminPanelComponent } from './admin-panel/base-admin-panel/group-base-admin-panel.component';
import { DriversDialogBaseComponent } from './admin-panel/Drivers/drivers-dialog-base/drivers-dialog-base.component';
import { GeozoneComponent } from "./admin-panel/Geozone/geozone/geozone.component";
import { CreateGeozoneDialogComponent } from "./admin-panel/Geozone/create-geozone-dialog/create-geozone-dialog.component";
import { EditKeyComponent } from "./admin-panel/Keys/edit-key.coponent";
import { CreateKeyComponent } from "./admin-panel/Keys/create-key.component";
import { ShiftsDialogBaseComponent } from './admin-panel/Shifts/shifts-dialog-base/shifts-dialog-base.component';
import { DialogBaseComponent } from './admin-panel/base-admin-panel/dialog-base/dialog-base.component';
import { CreateShiftComponent } from './admin-panel/Shifts/create-shift.component';
import { EditShiftComponent } from "./admin-panel/Shifts/edit-shift.component";
import { FooterComponentComponent } from "./admin-panel/base-admin-panel/footer-component/footer-component.component";
import { CreateDriverComponent } from "./admin-panel/Drivers/create-driver.component";
import { KeysDialogBaseComponent } from "./admin-panel/Keys/keys-dialog-base/keys-dialog-base.component";
import { EditDriverComponent } from "./admin-panel/Drivers/edit-driver.component";
import { PenaltyDialogComponent } from "./admin-panel/Drivers/penalty-dialog/penalty-dialog.component";
import { UsersDialogBaseComponent } from './admin-panel/Users/users-dialog-base/users-dialog-base.component';
import { CreateUserComponent } from './admin-panel/Users/create-user.component';
import { CreateRoutesComponent } from './admin-panel/Routes/create-routes.component';
import { EditRoutesComponent } from './admin-panel/Routes/edit-routes.component';
import { EditUserComponent } from "./admin-panel/Users/edit-user.component";
import { ObjectsDialogBaseComponent } from './admin-panel/Objects/objects-dialog-base/objects-dialog-base.component';
import { CreateObjectsComponent } from './admin-panel/Objects/create-objects.component';
import { EditObjectsComponent } from './admin-panel/Objects/edit-objects.component';
import { ObjectMainPartComponent } from './admin-panel/Objects/objects-dialog-base/object-main-part/object-main-part.component';
import { ObjectTrendsPartComponent } from './admin-panel/Objects/objects-dialog-base/object-trends-part/object-trends-part.component';
import { ObjectFuelPartComponent } from './admin-panel/Objects/objects-dialog-base/object-fuel-part/object-fuel-part.component';
import { ObjectEventsPartComponent } from './admin-panel/Objects/objects-dialog-base/object-events-part/object-events-part.component';
import { ObjectOdometerPartComponent } from './admin-panel/Objects/objects-dialog-base/object-odometer-part/object-odometer-part.component';
import {
  CalibrationSortPipe,
  TrendDialogBaseComponent
} from './admin-panel/Objects/objects-dialog-base/object-trends-part/trend-dialog-base/trend-dialog-base.component';
import { TrendBindingHistoryComponent } from './admin-panel/Objects/objects-dialog-base/object-trends-part/trend-binding-history/trend-binding-history.component';
import { BaseComponentWithDialog } from "./admin-panel/base-admin-panel/base-component-with-dialog";
import { DriverGroupMgmtComponent } from './admin-panel/Drivers/drivers-dialog-base/driver-group-mgmt/driver-group-mgmt.component';
import { BaseGroupMgmtComponentComponent } from './admin-panel/base-admin-panel/base-group-mgmt-component/base-group-mgmt-component.component';
import { RoutesDialogBaseComponent } from './admin-panel/Routes/routes-dialog-base/routes-dialog-base.component';
import { ZoneMgmtComponent } from './admin-panel/Routes/routes-dialog-base/zone-mgmt-component/zone-mgmt-component.component';
import {
  LocalizeMetersPipe, LocalizeKMetersPipe, LocalizeSpeedPipe, LocalizeUnitsPipe, LocalizeDaysPipe, LocalizeHoursPipe, DateTimePipe, TimePipe, LocalizeSecondsPipe
} from "./shared/pipes/Converter.pipe";
import { TasksDialogBaseComponent } from './admin-panel/Tasks/tasks-dialog-base/tasks-dialog-base.component';
import { CreateTaskComponent } from './admin-panel/Tasks/create-task.component';
import { EditTaskComponent } from "./admin-panel/Tasks/edit-task.component";
import { ColorSelectorComponent } from './shared/components/color-selector/color-selector.component';
import { IconSelectorComponent } from './shared/components/icon-selector/icon-selector.component';
import { GeozoneEditComponent } from './admin-panel/Geozone/geozone-edit/geozone-edit.component';
import { NotificationsComponent } from './admin-panel/Notifications/notifications/notifications.component';
import { NotificationsDialogBaseComponent } from './admin-panel/Notifications/notifications-dialog-base/notifications-dialog-base.component';
import { CreateNotificationComponent } from "./admin-panel/Notifications/create-notification.component";
import { EditNotificationComponent } from "./admin-panel/Notifications/edit-notification.component";
import { WeekDaySelectorComponent } from './shared/components/week-day-selector/week-day-selector.component';
import { MapDialogComponent } from './shared/components/map-dialog/map-dialog.component';
import { ImageWithDialogComponent } from './shared/components/image-with-dialog/image-with-dialog.component';
import { EntitiesListComponent } from './admin-panel/Users/EntitiesManagement/entities-list/entities-list.component';
import { EntityManipulationControlsComponent } from './admin-panel/Users/EntitiesManagement/entity-manipulation-controls/entity-manipulation-controls.component';
import { EntitiesListOrchestratorComponent } from './admin-panel/Users/EntitiesManagement/entities-list-orchestrator/entities-list-orchestrator.component';
import { ObjectsListOrchestratorComponent } from './admin-panel/Users/EntitiesManagement/objects-list-orchestrator/objects-list-orchestrator.component';
import { GeozonesListOrchestratorComponent } from "./admin-panel/Users/EntitiesManagement/geozones-list-orchestrator/geozones-list-orchestrator.component";
import { ObjectVechileSpecPartComponent } from './admin-panel/Objects/objects-dialog-base/object-vechile-spec-part/object-vechile-spec-part.component';

import { ObjectPhotoDialog } from './admin-panel/Objects/objects-dialog-base/object-photo-part/object-photo-dialog/object-photo-dialog.component';
import { ObjectPhotosComponent } from './admin-panel/Objects/objects-dialog-base/object-photo-part/object-photos/object-photos.component';

import { ObjectKeysSyncDialogComponent } from './admin-panel/Keys/objectkeys-sync-dialog/objectkeys-sync-dialog.component';
import { KeyObjectsSyncDialogComponent } from './admin-panel/Keys/keyobjects-sync-dialog/keyobjects-sync-dialog.component';
import { ServiceDialogBaseComponent } from './service/service-dialog-base/service-dialog-base.component';
import { CompletedWorksDialogBaseComponent } from './service/completed-works-dialog-base/completed-works-dialog-base.component';

import { ObjectIconDialogComponent } from "./admin-panel/Objects/object-icon-dialog/object-icon-dialog.component";
import { TrendInputComponent } from './admin-panel/Objects/objects-dialog-base/object-trends-part/trend-input/trend-input.component';
import { ObjectsReportComponent } from './dashboard/objects-report/objects-report.component';
import { ReportTemplatesComponent } from './admin-panel/Reports/report-templates/report-templates.component';
import { ReportDialogBaseComponent } from './admin-panel/Reports/report-dialog-base/report-dialog-base.component';
import { CreateReportTemplateComponent } from './admin-panel/Reports/create-report-template.component';
import { EditReportTemplateComponent } from './admin-panel/Reports/edit-report-template.component';
import { TrackingMapOnlyComponent } from './tracking/map-only/map-only.component';
import { SwitchAllCheckBoxComponent } from './shared/components/switch-all-checkbox/switch-all-checkbox.component';
import { CompaniesComponent } from './admin-panel/Companies/companies/companies.component';
import { CreateCompanyComponent } from './admin-panel/Companies/create-company/create-company.component';
import { CompaniesDialogBaseComponent } from './admin-panel/Companies/companies-dialog-base/companies-dialog-base.component';
import { EditCompanyComponent } from './admin-panel/Companies/edit-company/edit-company.component';
import { EntitiesListCompanyOrchestratorComponent } from './admin-panel/Companies/entities-list-company-orchestrator/entities-list-company-orchestrator.component';
import { ObjectServicelogPartComponent } from './admin-panel/Objects/objects-dialog-base/object-servicelog-part/object-servicelog-part.component';
import { RetranslatorsComponent } from "./admin-panel/retranslators/retranslations/retranslators.component";
import { RetranslatorDialogBaseComponent } from './admin-panel/retranslators/retranslator-dialog-base/retranslator-dialog-base.component';
import { CreateRetranslatorComponent } from "./admin-panel/retranslators/create-retranslator.component";
import { EditRetranslatorComponent } from "./admin-panel/retranslators/edit-retranslator.component";
import { ObjectMgmntComponent } from './admin-panel/retranslators/object-mgmnt/object-mgmnt.component';
import { MobileMapComponent } from './mobile-map/mobile-map.component';

import { MobileSystemComponent } from './mobile-system/mobile-system.component';
import { SharedMobileModule } from './shared-mobile.module';
import { SharedModule } from './shared.module';
import { ObjectsImportDialogComponent } from './admin-panel/Objects/objects-import-dialog/objects-import-dialog.component';
import { DragDropModule } from '@angular/cdk/drag-drop';


@NgModule({
  declarations: [
    SystemComponent,
    DeviceEditorComponent,
    MobileSystemComponent,
    ReportsComponent,
    DiagnosticsComponent,
    SetPayedTillDialogComponent,
    DataReportComponent,
    HistoryComponent,
    TrackingComponent,
    ServiceComponent,
    DriversComponent,
    DashboardComponent,
    DashboardSideNavComponent,
    NavigationComponent,
    PaginationComponent,
    PhotoDialogComponent,
    CommonDialogsComponent,
    CommandDialogComponent,
    UsersDialogComponent,
    SimpleMapComponent,
    ImageUploadComponent,
    FileUploadComponent,
    LeftTrackComponent,
    DevicesListComponent,
    GeozonesListComponent,
    DriversListComponent,
    DeviceInfoComponent,
    DeviceInfoMenuComponent,
    GeozoneInfoComponent,
    DriverInfoComponent,
    RightTrackComponent,
    RightComponentWithCollapsedPanel,
    EventsListComponent,
    LeftReportComponent,
    TrendListComponent,
    DriversDashboardComponent,
    DriversSideNavComponent,
    DriversReportComponent,
    DriversRatingComponent,
    DriverAnaliticsComponent,
    TrackInfoWithViolationsComponent,
    ViolationsListComponent,
    DriversStatComponent,
    DispatcherComponent,
    DispatcherSideNavComponent,
    DispatcherTableComponent,
    DispatcherReportComponent,
    DropdownDirective,
    RawDataHistoryComponent,
    ShortTrendComponent,
    TrackInfoComponent,
    ObjectsStatComponent,
    RightHistoryComponent,
    RawDataComponent,
    DailyStatComponent,
    DriverSessionsComponent,
    LeftDataComponent,
    ServiceSideNavComponent,
    ServiceTasksListComponent,
    CompletedWorksListComponent,
    ServiceTasksReportComponent,
    AdminPanelComponent,
    SideNavComponent,
    CommandsComponent,
    FilterByNamePipe,
    FilterByNameAndListPipe,
    FilterByNameAndGroupPipe,
    FilterTasksPipe,
    FilterObjectsPipe,
    FilterKeysPipe,
    FilterByPagesPipe,
    ZoneOrderPipe,
    CreateCommandComponent,
    EditCommandComponent,
    CommandDialogBaseComponent,
    AdminDriversComponent,
    ObjectsManagementDialogComponent,
    GroupFilterComponent,
    GroupManagementDialogComponent,
    ObjectsComponentComponent,
    UsersComponent,
    KeysComponent,
    TasksComponent,
    RoutesComponent,
    ShiftsComponent,
    ServerAdminComponent,
    ServerStatusComponent,
    ServerSettingsComponent,
    DomainSettingsComponent,
    BaseAdminPanelComponent,
    BaseComponentWithDialog,
    GroupBaseAdminPanelComponent,
    DriversDialogBaseComponent,
    CreateDriverComponent,
    EditDriverComponent,
    PenaltyDialogComponent,
    GeozoneComponent,
    CreateGeozoneDialogComponent,
    KeysDialogBaseComponent,
    CreateKeyComponent,
    EditKeyComponent,
    CreateTaskComponent,
    EditTaskComponent,
    ShiftsDialogBaseComponent,
    DialogBaseComponent,
    CreateShiftComponent,
    EditShiftComponent,
    FooterComponentComponent,
    UsersDialogBaseComponent,
    CreateUserComponent,
    EditUserComponent,
    ObjectsDialogBaseComponent,
    CreateObjectsComponent,
    EditObjectsComponent,
    ObjectMainPartComponent,
    ObjectTrendsPartComponent,
    ObjectFuelPartComponent,
    ObjectEventsPartComponent,
    ObjectOdometerPartComponent,
    TrendDialogBaseComponent,
    DriverGroupMgmtComponent,
    BaseGroupMgmtComponentComponent,
    CalibrationSortPipe,
    RoutesDialogBaseComponent,
    EditRoutesComponent,
    CreateRoutesComponent,
    ZoneMgmtComponent,
    LocalizeSpeedPipe,
    LocalizeUnitsPipe,
    LocalizeMetersPipe,
    LocalizeKMetersPipe,
    LocalizeHoursPipe,
    LocalizeSecondsPipe,
    LocalizeDaysPipe,
    TimePipe,
    TasksDialogBaseComponent,
    ColorSelectorComponent,
    IconSelectorComponent,
    GeozoneEditComponent,
    NotificationsComponent,
    NotificationsDialogBaseComponent,
    CreateNotificationComponent,
    EditNotificationComponent,
    WeekDaySelectorComponent,
    MapDialogComponent,
    ImageWithDialogComponent,
    EntitiesListComponent,
    EntityManipulationControlsComponent,
    EntitiesListOrchestratorComponent,
    ObjectsListOrchestratorComponent,
    GeozonesListOrchestratorComponent,
    ObjectVechileSpecPartComponent,
    ObjectPhotoDialog,
    ObjectPhotosComponent,
    ObjectKeysSyncDialogComponent,
    KeyObjectsSyncDialogComponent,
    ServiceDialogBaseComponent,
    CompletedWorksDialogBaseComponent,
    RaceDialogBaseComponent,
    RaceDevicesDialogComponent,
    RacesComponent,
    RaceComponent,
    GapComponent,
    ServiceCheckupsComponent,
    ObjectsFilterComponent,
    NotificationPanelComponent,
    PhotoGalleryDialogComponent,
    ObjectIconDialogComponent,
    TrendBindingHistoryComponent,
    TrendInputComponent,
    ObjectsDashboardComponent,
    ObjectsReportComponent,
    ReportTemplatesComponent,
    ReportDialogBaseComponent,
    CreateReportTemplateComponent,
    EditReportTemplateComponent,
    TrackingMapOnlyComponent,
    SwitchAllCheckBoxComponent,
    CompaniesComponent,
    CreateCompanyComponent,
    CompaniesDialogBaseComponent,
    EditCompanyComponent,
    EntitiesListCompanyOrchestratorComponent,
    ObjectServicelogPartComponent,
    RetranslatorsComponent,
    CreateRetranslatorComponent,
    EditRetranslatorComponent,
    RetranslatorDialogBaseComponent,
    ObjectMgmntComponent,
    MobileMapComponent,
    ObjectsImportDialogComponent,
    ObjectGreenDrivingComponent
  ], imports: [CommonModule,
    DragDropModule,
    SystemRoutingModule,
    TranslateModule,
    FormsModule,
    SharedMobileModule,
    SharedModule], providers: [LocalizeMetersPipe, provideHttpClient(withInterceptorsFromDi())]
})

export class SystemModule {
}
